export default function deformatPhoneNumber(phoneNumber: string): string {
  if (!phoneNumber) {
    return ''
  }
  return '0' + phoneNumber.replaceAll(' ', '').substring(3)
}
